import { render } from "./ListarTaxasPagamentos.vue?vue&type=template&id=99ef458e"
import script from "./ListarTaxasPagamentos.vue?vue&type=script&lang=js"
export * from "./ListarTaxasPagamentos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__